import { Button } from "antd";
import { ItemType, MenuItemType } from "antd/es/menu/hooks/useItems";

const CenterMenu: ItemType<MenuItemType>[] = [
    // {
    //     label: (<a href="https://kiemtrahoadon.vn/" target="_blank">Kiểm tra hóa đơn hợp lệ</a>),
    //     danger: true,
    //     title: "Kiểm tra hóa đơn hợp lệ",
    //     key: "kiem-tra-hoa-don",
    // },
    // {
    //     label: "Hỏi đáp",
    //     title: "Hỏi đáp",
    //     key: "hoi-dap",
    //     children: [
    //         {
    //             label: (<a href="https://minvoice.vn/hoi-dap-hoa-don-dien-tu/" target="_blank">Hỏi đáp hóa đơn điện tử</a>),
    //             key: "hoi-dap-hoa-don-dien-tu",
    //             title: "Hỏi đáp hóa đơn điện tử"
    //         },
    //         {
    //             label: (<a href="https://minvoice.vn/hoi-dap-tin-tuc-hoa-don-dien-tu/quy-dinh-ve-hoa-don-dien-tu/" target="_blank">Kiến thức hóa đơn điện tử</a>),
    //             key: "https://minvoice.vn/hoi-dap-tin-tuc-hoa-don-dien-tu/quy-dinh-ve-hoa-don-dien-tu/",
    //             title: "quy-dinh-ve-hoa-don-dien-tu"
    //         },
    //         {
    //             label: (<a href="https://minvoice.vn/hoi-dap-tin-tuc-hoa-don-dien-tu/van-ban-hoa-don-dien-tu/" target="_blank">Văn bản hóa đơn điện tử</a>),
    //             key: "van-ban-hoa-don-dien-tu",
    //             title: "Văn bản hóa đơn điện tử"
    //         },
    //         {
    //             label: (<a href="https://minvoice.vn/hoi-dap-tin-tuc-hoa-don-dien-tu/" target="_blank">Tin tức</a>),
    //             key: "hoi-dap-tin-tuc-hoa-don-dien-tu",
    //             title: "Tin tức"
    //         },

    //     ]
    // },
    {
        label: "Sản phẩm",
        title: "Sản phẩm",
        key: "san-pham",
        children: [
            {
                label: (<a href="https://minvoice.vn/" target="_blank">Bảo hiểm xã hội điện tử</a>),
                key: "bao-hiem-xa-hoi-minvoice",
                title: "Bảo hiểm xã hội điện tử"
            },
            {
                label: (<a href="https://minvoice.vn/" target="_blank">Quản lý hóa đơn</a>),
                key: "smi-minvoice",
                title: "Quản lý hóa đơn"
            },
            {
                label: (<a href="https://minvoice.vn/" target="_blank">Hợp đồng điện tử</a>),
                key: "me-contract-hop-dong-dien-tu-minvoice",
                title: "Hợp đồng điện tử"
            }
        ]
    },
    {
        label: (<a href="https://minvoice.vn/dang-ky-su-dung/" target="_blank">Mua hàng</a>),
        title: "Mua hàng",
        key: "mua-hang-minvoice",
        danger:true
    },
    {
        label: (<Button style={{ color: "white" }} type="primary" href="https://minvoice.vn/dang-ky-dai-ly-hoa-don-dien-tu/" target="_blank">Đăng ký đại lý</Button>),
        title: "",
        key: "dang-ky-dai-ly-minvoice"
    }
]
export default { CenterMenu }